import { Directive, ElementRef, HostListener, AfterViewInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { UtilService } from '../services/util.service';
import { UtilitiesService } from '../services/utilities.service';

/*
 * Directive to add 'drag' support to Ngx Bootstrap modals (https://github.com/valor-software/ngx-bootstrap).
 * Based on this library to enable drag support for an ng-bootstrap modal: https://github.com/mattxu-zz/ngb-modal-draggable
 *
 * Enable by adding the directive to the modal-header element, e.g.:
 *
 * <div class="modal-header" ngxModalDraggable>  </div>
 */

@Directive({
    selector: '[ngxModalDraggable]',
    standalone: false
})
export class NgxModalDraggableDirective implements AfterViewInit {
  private modalElement: HTMLElement;
  private topStart: number;
  private leftStart: number;
  private isDraggable: boolean;
  private handleElement: HTMLElement;

  serVal: any;


  constructor
    (public element: ElementRef,
      public ngZone: NgZone,
      public cdr: ChangeDetectorRef,
      private utilitiesService: UtilitiesService,
      private utilService: UtilService
    ) {
    if (!this.utilService.isMobile()) {
      this.serVal = this.utilitiesService.documentMouseDownTarget
        .subscribe(target => {
          this.onMouseDown(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
      this.serVal = this.utilitiesService.documentMouseUpTarget
        .subscribe(target => {
          this.onMouseUp(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
      this.serVal = this.utilitiesService.documentMouseMoveTarget
        .subscribe(target => {
          this.onMouseMove(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
      this.serVal = this.utilitiesService.documentMouseLeaveTarget
        .subscribe(target => {
          this.onMouseLeave(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
    } else {
      this.serVal = this.utilitiesService.documentTouchStartTarget
        .subscribe(target => {
          this.onMouseDown(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
      this.serVal = this.utilitiesService.documentTouchEndTarget
        .subscribe(target => {
          this.onMouseUp(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
      this.serVal = this.utilitiesService.documentTouchMoveTarget
        .subscribe(target => {
          this.onMouseMove(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
      this.serVal = this.utilitiesService.documentTouchCancelTarget
        .subscribe(target => {
          this.onMouseLeave(target);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        });
    }
  }

  ngAfterViewInit() {
    // debugger;
    let element = this.element.nativeElement;

    //only make the modal header draggable
    this.handleElement = this.element.nativeElement;

    //change cursor on the header
    this.handleElement.style.cursor = 'all-scroll';

    //get the modal parent container element: that's the element we're going to move around
    for (let level = 3; level > 0; level--) {
      element = element.parentNode;
    }

    this.modalElement = element;
    this.modalElement.style.position = 'relative';
  }

  // @HostListener('mousedown', ['$event'])
  onMouseDown(event) {
    // this.ngZone.runOutsideAngular(() => {
    if (this.utilService.isMobile()) {
      return
      // var event1 = event.touches[0];
      // this.isDraggable = true;
      // document.documentElement.style.overflow = 'hidden';

      // //store original position
      // this.topStart = event1.clientY - Number(this.modalElement.style.top.replace('px', ''));
      // this.leftStart = event1.clientX - Number(this.modalElement.style.left.replace('px', ''));
      // // event.preventDefault();
      // event.stopPropagation();
    } else {
      if (event.button === 2 || (this.handleElement && event.target !== this.handleElement)) {
        return; // prevents right click drag
      }
      //enable dragging
      this.isDraggable = true;

      //store original position
      this.topStart = event.clientY - Number(this.modalElement.style.top.replace('px', ''));
      this.leftStart = event.clientX - Number(this.modalElement.style.left.replace('px', ''));
      event.preventDefault();
    }
    // })

  }

  // @HostListener('document:mouseup', ['$event'])
  onMouseUp(event) {
    this.isDraggable = false;
    if (this.utilService.isMobile()) {
      document.documentElement.style.overflow = 'auto';
    }
    // this.ngZone.runOutsideAngular(() => {  })
  }

  // @HostListener('document:mousemove', ['$event'])
  onMouseMove(event) {
    // this.ngZone.runOutsideAngular(() => {
    // debugger;
    if (this.isDraggable) {
      //on moving the mouse, reposition the modal
      if (this.utilService.isMobile()) {
        return
        // var e = event.touches[0];
        // this.modalElement.style.top = (e.clientY - this.topStart) + 'px';
        // this.modalElement.style.left = (e.clientX - this.leftStart) + 'px';
      } else {
        this.modalElement.style.top = (event.clientY - this.topStart) + 'px';
        this.modalElement.style.left = (event.clientX - this.leftStart) + 'px';
      }

    }
    // })

  }

  // @HostListener('document:mouseleave', ['$event'])
  onMouseLeave(event) {
    this.isDraggable = false;
    if (this.utilService.isMobile()) {
      document.documentElement.style.overflow = 'auto';
    }
    // this.ngZone.runOutsideAngular(() => {  })
  }

}